import { createRouter, createWebHistory } from 'vue-router'
import type { IStaticMethods } from 'preline/preline'

declare global {
  interface Window {
    HSStaticMethods: IStaticMethods
  }
}

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/HomeView.vue'),
    },
    {
      path: '/companies',
      name: 'companies',
      component: () => import('@/views/AppsView.vue'),
    },
    {
      path: '/companies/:slug',
      name: 'company-detail',
      component: () => import('@/views/AppDetailView.vue'),
      props: true,
    },
    {
      path: '/story',
      name: 'story',
      component: () => import('@/views/StoryView.vue'),
    },
    {
      path: '/mission',
      name: 'mission',
      component: () => import('@/views/MissionView.vue'),
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import('@/views/PoliciesView.vue'),
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/views/ContactView.vue'),
    },
    // Legacy redirects — keep old URLs working
    { path: '/apps', redirect: '/companies' },
    { path: '/apps/:slug', redirect: (to) => `/companies/${to.params.slug}` },
    { path: '/policies', redirect: '/terms' },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@/views/NotFoundView.vue'),
    },
  ],
  scrollBehavior(to, _from, saved) {
    if (saved) return saved
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    return { top: 0 }
  },
})

router.afterEach((_to, _from, failure) => {
  if (!failure) {
    setTimeout(() => {
      window.HSStaticMethods?.autoInit()
    }, 100)
  }
})

export default router
